import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Input, Form, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import axios from "axios";
import { PlusOutlined } from '@ant-design/icons';

import { ReloadTrue, hideLoading, showLoading } from "../redux/rootSlice";

const AdminProject = () => {
    const { portfolioData } = useSelector((state) => state.root);
    const { projects } = portfolioData; // Use optional chaining
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalEdit, setIsModalEdit] = useState(false);
    const [selectItemEdit, setselectItemEdit] = useState(null);
    const dispatch = useDispatch();
    const [form] = Form.useForm();

    useEffect(() => {
        if (isModalEdit) {
            form.setFieldsValue({
                title: selectItemEdit.title,
                desc: selectItemEdit.desc,
                img: selectItemEdit.img,
                preview: selectItemEdit.preview,
                technology: selectItemEdit.technology,
            });
        }
    }, [isModalEdit, selectItemEdit, form]);

    const showModal = () => {
        setIsModalOpen(true);
        if (!isModalEdit) {
            form.resetFields();
        }
    };

    const handleOk = () => {
        setIsModalOpen(false);
        setIsModalEdit(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setIsModalEdit(false);
    };

    const onFinish = async (values) => {
        try {
            setIsModalEdit(false);
            dispatch(showLoading());
            handleOk();
            let response;

            if (isModalEdit) {
                response = await axios.post(
                    `https://backendz182.up.railway.app/api/portfolio/update-project/${selectItemEdit?._id}`,
                    values
                );
            } else {
                response = await axios.post("https://backendz182.up.railway.app/api/portfolio/add-project", values);
            }
            dispatch(hideLoading());

            if (response.data.success) {
                message.success(response.data.message);
                dispatch(ReloadTrue());
                form.resetFields();
            } else {
                message.error(response.data.message);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };


    const onDelete = async (id) => {
        try {
            const isConfirmed = window.confirm(
                "Are you sure you want to delete this project?"
            );
            if (isConfirmed) {
                dispatch(showLoading());
                const response = await axios.delete(
                    `api/portfolio/delete-project/${id}`
                );
                console.log(response);
                dispatch(hideLoading());

                if (response.data.success) {
                    message.success(response.data.message);
                    // Dispatch the action after a successful API call
                    dispatch(ReloadTrue());
                } else {
                    message.error(response.data.message);
                }
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    return (
        <>
            <div>
                <div className="flex  items-center justify-between">
                    <p className="text-xl font-bold">Add Projects</p>
                    <button
                        type="button"
                        onClick={showModal}
                        className="button bg-primary dark:bg-bg-dark p-3 font-medium text-white rounded hover:bg-secondary  hover:font-semibold ease-in-out">
                        Add Projects&nbsp;
                        <PlusOutlined />
                    </button>
                </div>
                <div className="flex gap-5 justify-around flex-wrap  py-10 sm:flex-col md:flex-col ">
                    {projects
                        .slice()
                        .reverse()
                        .map((project) => {
                            return (
                                <div
                                    className="cardProject  bg-slate-200 shadow px-8 py-5 rounded flex flex-col gap-2 sm:w-full"
                                    key={project._id}>
                                    <img
                                        className="pt-3 projectImg pb-4"
                                        src={project.img}
                                        alt=""
                                    />
                                    <p className="text-primary font-bold title text-xl">
                                        {project.title}
                                    </p>

                                    <p className=" font-semibold">
                                        Technology : &nbsp;{" "}
                                        <strong className="text-primary">
                                            {" "}
                                            {project.technology}
                                        </strong>
                                    </p>
                                    <p className=" descPro">{project.desc}</p>
                                    <div className="flex gap-3 justify-end">
                                        <button
                                            className="button border py-2 px-4 rounded border-outline border-primary font-medium hover:bg-red-700 hover:border-red-700 hover:text-tertiary ease-in-out"
                                            onClick={() => {
                                                onDelete(project._id);
                                            }}>
                                            Delete
                                        </button>
                                        <button
                                            className="button border py-2 px-4  rounded border-outline border-primary bg-primary/90  dark:bg-bg-dark/90 text-tertiary font-medium hover:bg-primary hover:border-primary hover:text-tertiary  hover:font-semibold ease-in-out"
                                            onClick={() => {
                                                setselectItemEdit(project);
                                                setIsModalEdit(true);
                                                showModal();
                                                console.log(selectItemEdit);
                                            }}>
                                            Edit
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                </div>
            </div>

            <div>
                <Modal
                    title={isModalEdit ? "Edit Project" : "Add Project"}
                    footer={null}
                    style={{ width: 750 }}
                    open={isModalOpen}
                    onOk={handleOk}
                    onFinish={onFinish}
                    onCancel={handleCancel}>
                    <Form
                        onFinish={onFinish}
                        layout="vertical"
                        form={form}
                        initialValues={isModalEdit ? {} : null}>
                        <Form.Item
                            label="Title"
                            name="title"
                            className="font-semibold"
                            rules={[{ required: true, message: "Please enter the title." }]}>
                            <Input className=" h-[40px]" placeholder="Enter Title" />
                        </Form.Item>

                        <Form.Item
                            label="Description"
                            name="desc"
                            className="font-semibold"
                            rules={[
                                { required: true, message: "Please enter the description." },
                            ]}>
                            <TextArea
                                rows={3}
                                className="  h-[40px]"
                                placeholder="Enter Description"
                            />
                        </Form.Item>

                        <Form.Item
                            label="Image URL"
                            name="img"
                            className="font-semibold"
                            rules={[
                                { required: true, message: "Please enter the image URL." },
                            ]}>
                            <Input className=" h-[40px]" placeholder="Enter Image URL" />
                        </Form.Item>

                        <Form.Item
                            label="Preview URL"
                            name="preview"
                            className="font-semibold"
                            rules={[
                                { required: true, message: "Please enter the preview URL." },
                            ]}>
                            <Input className=" h-[40px]" placeholder="Enter Preview URL" />
                        </Form.Item>

                        <Form.Item
                            label="Technolgy"
                            name="technology"
                            className="font-semibold"
                            rules={[
                                { required: true, message: "Please enter the technology." },
                            ]}>
                            <Input className=" h-[40px]" placeholder="Enter Technolgy" />
                        </Form.Item>

                        <div className="flex gap-3 justify-end">
                            <button
                                onClick={() => {
                                    handleCancel();
                                    setIsModalEdit(false);
                                }}
                                className="button border p-2 rounded border-outline border-primary font-medium hover:bg-primary hover:text-tertiary ease-in-out">
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="button border p-2 rounded border-outline border-primary bg-primary text-tertiary font-medium hover:bg-secondary hover:border-secondary hover:text-tertiary hover:font-semibold ease-in-out"
                                disabled={form.isFieldsTouched(true) && form.getFieldsError().filter(({ errors }) => errors.length).length > 0}
                            >
                                {isModalEdit ? "Save Project" : "Add Project"}
                            </button>

                        </div>
                    </Form>
                </Modal>
            </div>
        </>
    );
};

export default AdminProject;
